"use strict";

import React, {createRef} from "react";

import {Select} from "@/components/select/Select.tsx";
import {FieldErrors, FieldHelpText, Label, uniqueHtmlId, unpackFormLinkOrProps} from "@/legacy/form/FormHelpers.jsx";

export default class SelectBox extends React.Component {
  constructor(props) {
    super(props);
    this.htmlId = uniqueHtmlId(props.fieldName);
    this.selectBox = createRef();
  }

  focus() {
    this.selectBox.current.focus();
  }

  render() {
    const form = unpackFormLinkOrProps(this.props);
    const choices = this.props.choices || [];
    const groups = this.props.groups || {};
    const selectOptions = [];
    const flatOptions = [];

    if (this.props.allowEmpty) {
      const emptyOption = {
        value: "",
        label: this.props.emptyLabel,
      };
      selectOptions.push(emptyOption);
      flatOptions.push(emptyOption);
    }

    for (const [groupName, groupChoices] of Object.entries(groups)) {
      const groupOptions = groupChoices.map(([value, label]) => ({value, label}));
      selectOptions.push({
        label: groupName,
        options: groupOptions,
      });
      flatOptions.push(...groupOptions);
    }

    if (choices && choices.length > 0) {
      const ungroupedOptions = choices.map(([value, label]) => ({value, label}));
      selectOptions.push(...ungroupedOptions);
      flatOptions.push(...ungroupedOptions);
    }

    return (
      <div className={this.props.formGroupClass}>
        <Label fieldId={this.htmlId} {...this.props} />
        <Select
          ref={this.selectBox}
          id={this.htmlId}
          inputId={this.htmlId}
          name={this.props.fieldName}
          aria-invalid={!!form.errors}
          options={selectOptions}
          disabled={this.props.disabled}
          value={flatOptions.find((option) => option.value === form.value) || null}
          onChange={(value) =>
            form.onChange(
              value
                ? {target: {type: "fakedEvent", name: this.props.fieldName, value: value.value}}
                : {target: {type: "fakedEvent", name: this.props.fieldName, value: ""}}
            )
          }
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
        />
        <FieldErrors errors={form.errors} />
        <FieldHelpText {...this.props} />
      </div>
    );
  }
}

SelectBox.defaultProps = {
  fieldName: "", // Field name returned in form data
  labelText: null, // Label of this field
  titleText: null, // Tooltip
  helpText: null, // Help text beneath the field
  isRequired: false, // Field is required?
  disabled: false, // Control is disabled?
  allowEmpty: false, // Add an extra empty option to the select box.
  emptyLabel: "------------", //default label for empty value
  choices: [], // Array of 2-tuples: [key, value] select box choices.
  groups: {}, // Object containg grouped [key, value] choices. Group keys are used as
  // choices separators
  formGroupClass: "form-group", // CSS classes for the form-group div

  formLink: null, // Object from prepareFormLink() to auto-bind value, onChange, formErrors
  value: null, // React field value
  formErrors: null, // Dict of all form errors, possibly with an entry for fieldName

  onChange: null, // Change handler
  onFocus: null, // Focus handler
  onBlur: null, // Blur handler
};
